import { defineComponent as _defineComponent } from 'vue'
import CheckIcon from '@/components/svg/disk.svg?inline';
import { ref, toRefs, watch } from 'vue';
import animationFrameWait from '@/utils/animationFrameWait';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXEditedIndicator',
  props: {
  trigger: {
    type: Number,
    default: 0
  },
},
  setup(__props) {

const props = __props;

const isTriggered = ref(false);



const { trigger } = toRefs(props);

watch(trigger, async () => {
  isTriggered.value = false;
  await animationFrameWait(1);
  isTriggered.value = true;
});


return { __sfc: true,isTriggered, props, trigger, CheckIcon }
}

})